import React, {Component} from 'react';
import {NavLink, withRouter, Route} from 'react-router-dom';
import SpecificUser from './SpecificUser';
import Icons from '../../../Containers/Icons';
import lang from '../../Lang/lang.json';

class UserConf extends Component {
  constructor(props){
    super(props);
    this.state = {
      users: "",
      newUser: {
        name: "",
        email: "",
        pass: ""
      }
    }
  }
  componentDidMount() {
    this.readUsers();
    this.props.changeScreen("UsrCnf");
  }
  getUsrData = (event) => {
    let newUser = {...this.state.newUser};
    newUser[event.target.name] =  event.target.value;
    this.setState({newUser: newUser});
  }
  saveUserData = () => {
    console.log("saving user");
    let {name, email, pass} = this.state.newUser;
    let bodyCall = {
      type: "create",
      screen: "user",
      post: {
        name: name,
        email: email,
        pass: pass,
        super: 0
      },
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if (res === true) {
        if (res.tkn === false) {
          this.props.logOut();
        } else {
          this.props.msg("ok", "e09");
          this.props.funct("UsrCnf");
          this.readUsers();
          this.clearNewUser();
        }
      } else if (res.includes("Duplicate")){
        this.props.msg("error", "e08");
        this.clearNewUser();
        console.log(res);
      }
    })
  }
  clearNewUser = () => {
    let inputs = document.querySelectorAll("input");
    Object.keys(inputs).map((key) => {
      inputs[key].value = "";
      return true;
    })
    this.props.funct("UsrCnf");
  }
  readUsers = (screen = false) => {
    console.log("Reading users...");
    let bodyCall = {
      type: "read",
      screen: "user-conf",
      tkn: this.props.tkn
    }
    fetch(`${this.props.url}api.php`, {
      method: 'post',
      headers: {'Content-type': 'application/json'},
      body: JSON.stringify(bodyCall)
    }).then(res => res.json()).then(res => {
      if (res.hasOwnProperty("tkn")){
        this.props.history.push("/")
      } else  {
        if (screen) {
          this.setState({users: res})
          this.props.changeScreen("SelectedUsr");
        } else {
          this.setState({users: res})
        }
      }
    })
  }
  render() {
    let users = this.state.users;
    let openMod;
    this.props.openMod
    ? openMod = "open"
    : openMod = "closed"

    return (
      <div id="userconf">
        <Route path='/home/admin/usr/:id' render={(path) => {
          let users = this.state.users;
          let slUser = Object.keys(users).find(key => {
            return users[key].id === path.match.params.id;
          })
          users = users[slUser];
          return (
            <SpecificUser
              selectUser={this.props.selectUser}
              readUsers={this.readUsers}
              language={this.props.language}
              openModPass={this.props.openModPass}
              openModDel={this.props.openModDel}
              tableros={this.props.tableros} 
              url={this.props.url}
              tkn={this.props.tkn}
              changeScreen={this.props.changeScreen} 
              user={users}
              funct={this.props.funct}
              msg={this.props.msg}/>
          )
        }}/>
        <Route path='/home/admin/usr' exact render={() => {
          return (
            <div>
              <ul>
              {
                Object.keys(users).map(el => {
                  return (
                    <NavLink 
                      key={el}
                      to={`/home/admin/usr/${users[el].id}`}
                      onClick={() => this.props.selectUser(users[el])}>
                      <li key={el}>{users[el].name}<span className="arrow gray"><Icons name="arrowThin"/></span></li>
                    </NavLink>
                  )
                })
              }
              </ul>
              <form className={`modal add ${openMod}`}>
                <h3>{lang.UsrCnf.title[this.props.language]}</h3>
                <input 
                  autoComplete="Name"
                  name="name"
                  type="text" 
                  placeholder={lang.UsrCnf.name[this.props.language]}
                  onChange={this.getUsrData}/>
                <input 
                  autoComplete="E-mail"
                  name="email" 
                  type="e-mail" 
                  placeholder={lang.UsrCnf.email[this.props.language]}
                  onChange={this.getUsrData}/>
                <input 
                  autoComplete="Password"
                  name="pass"
                  type="password" 
                  placeholder={lang.UsrCnf.pass[this.props.language]}
                  onChange={this.getUsrData}/>
                <span className="formButtonsContainer">
                  <span className="formButton ok" onClick={this.saveUserData}>
                    <Icons name="ok"/>
                  </span>
                  <span className="formButton close" onClick={this.clearNewUser}>
                    <Icons name="close"/>
                  </span>
                </span>
              </form>
            </div>
          )
        }}/>
      </div>
    )
  }
}

export default withRouter(UserConf);


// WEBPACK FOOTER //
// ./src/Components/Admin/User/UserConf.js